import { render, staticRenderFns } from "./VerifiedEmailModal.vue?vue&type=template&id=78de4eb3&"
import script from "./VerifiedEmailModal.vue?vue&type=script&lang=js&"
export * from "./VerifiedEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports